import React from 'react';
import { motion } from 'framer-motion';
import Loading from './Loading';

const LoadingAnimation = ({ progress = 0 }) => (
    <motion.div
        key="loading"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
    >
        <Loading progress={progress} />
    </motion.div>
);

export default LoadingAnimation;